import * as React from "react";
import { FormComponent } from "../../../../../../../../react-core/Html/FormComponent";
import { Navigator } from "../../../../../../../Shared/Wizards/Entities/Navigator";
import { Urls } from "../../../../../../Urls";
import { AssetsToSellTable } from "./AssetsToSellTable";
import { PaymentDetails } from "./PaymentDetails";
import { DrawdownIncomeAmendmentModel } from "../../../../../../../../Wrap/Models/Models/Processes/Drawdown/DrawdownIncomeAmendmentModel";

interface IIncomePaymentDetailsProps {
    data: DrawdownIncomeAmendmentModel;
    arrangementId?: number;
}

interface IIncomePaymentDetailsState {}

export class IncomePaymentDetails extends FormComponent<IIncomePaymentDetailsProps, IIncomePaymentDetailsState> {
    constructor(props: any) {
        super(props);
    }

    public render(): JSX.Element {
        const { data, arrangementId } = this.props;
        const arrangementValuationForGADReview = data?.DrawdownIncomeAmendmentInstruction?.CappedArrangements?.find(x => x.PensionArrangementId == arrangementId)?.Amount ?? 0;
        return (
            <>
                <div className="row narrow-gutter">
                    <h2 className="col-fluid heading-underlined mt-20">Income payment details</h2>
                    <div className="col-auto">
                        <button
                            className="edit-circle-icon-button label-sr-only"
                            title="Edit"
                            onClick={() => {
                                Navigator.navigateToAndPreserveQueryParameters(
                                    Urls.get().GadReviewIncomePaymentDetails
                                );
                            }}
                        >
                            <span className="icon" aria-hidden="true"></span>
                            <span className="text">Edit</span>
                        </button>
                    </div>
                </div>
                <PaymentDetails data={data} arrangementId={arrangementId} arrangementValuationForGADReview={arrangementValuationForGADReview} />
                <AssetsToSellTable
                    existingData={data?.PensionLevelDrawdownIncomeAmendmentCalculations?.IncomeDisinvestmentAllocations || []}
                    tableData={data?.DrawdownIncomeAmendmentInstruction?.IncomeDisinvestmentAllocations || []}

                />
            </>
        );
    }
}
